import React, { useState } from 'react';
import './PartnershipModal.css';

function PartnershipModal({ isOpen, onClose }) {
  const [businessType, setBusinessType] = useState('Manufacturer');
  const [formData, setFormData] = useState({
    enterpriseName: '',
    gstNumber: '',
    companyWebsite: '',
    contactPersonRole: '',
    fullName: '',
    mobileNumber: '',
    emailAddress: ''
  });
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const response = await fetch('https://proderp.gbru.in/api/method/warrior.apis.scripts.add_product_enquires', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-KEY': 'SHOPTION_XYZ_9834SDJKS',
          'X-API-SECRET': 'SHOPTION_SECRET_99ASD9A8S9D'
        },
        body: JSON.stringify({ businessType, ...formData })
      });
      
      const result = await response.json();
      console.log('Partnership Enquiry Response:', result);
      
      // Checking for result.message.status as per documentation
      if (result.message && result.message.status) {
        setShowSuccess(true);
        setTimeout(() => {
          setShowSuccess(false);
          onClose();
          setFormData({
            enterpriseName: '',
            gstNumber: '',
            companyWebsite: '',
            contactPersonRole: '',
            fullName: '',
            mobileNumber: '',
            emailAddress: ''
          });
        }, 3000);
      } else {
        const errorMsg = result.message?.message || result._server_messages || 'Authentication/Permission Error';
        alert(errorMsg);
      }
    } catch (error) {
      console.error('Submission error:', error);
      alert('Failed to submit enquiry');
    }
    setLoading(false);
  };


  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        {showSuccess ? (
          <div className="success-message">
            <div className="success-icon">✓</div>
            <h2>Enquiry Submitted Successfully!</h2>
            <p>Our business administrative team will contact you soon.</p>
          </div>
        ) : (
          <>
            <div className="modal-header">
              <h2>Partnership Inquiry</h2>
              <button className="modal-close" onClick={onClose}>×</button>
            </div>
            
            <form className="partnership-form" onSubmit={handleSubmit}>
          <div className="form-section">
            <label className="form-label">Business Type</label>
            <div className="radio-grid">
              {['Manufacturer', 'Distributor', 'Dealer', 'Other'].map((type) => (
                <label key={type} className="radio-option">
                  <input
                    type="radio"
                    name="businessType"
                    value={type}
                    checked={businessType === type}
                    onChange={(e) => setBusinessType(e.target.value)}
                  />
                  <span>{type}</span>
                </label>
              ))}
            </div>
          </div>

          <div className="form-section">
            <label className="form-label">Enterprise Information</label>
            <div className="input-grid">
              <input type="text" placeholder="Enterprise Name*" className="form-input" value={formData.enterpriseName} onChange={(e) => setFormData({...formData, enterpriseName: e.target.value})} required />
              <input type="text" placeholder="GST Number*" className="form-input" value={formData.gstNumber} onChange={(e) => setFormData({...formData, gstNumber: e.target.value})} required />
            </div>
            <input type="text" placeholder="Company Website" className="form-input full-width" value={formData.companyWebsite} onChange={(e) => setFormData({...formData, companyWebsite: e.target.value})} />
          </div>

          <div className="form-section">
            <label className="form-label">Primary Contact</label>
            <div className="input-grid">
              <input type="text" placeholder="Contact Person's Role*" className="form-input" value={formData.contactPersonRole} onChange={(e) => setFormData({...formData, contactPersonRole: e.target.value})} required />
              <input type="text" placeholder="Full Name*" className="form-input" value={formData.fullName} onChange={(e) => setFormData({...formData, fullName: e.target.value})} required />
              <input type="tel" placeholder="Mobile Number*" className="form-input" value={formData.mobileNumber} onChange={(e) => setFormData({...formData, mobileNumber: e.target.value})} required />
              <input type="email" placeholder="Email Address*" className="form-input" value={formData.emailAddress} onChange={(e) => setFormData({...formData, emailAddress: e.target.value})} required />
            </div>
          </div>

              <button type="submit" className="submit-btn" disabled={loading}>{loading ? 'Submitting...' : 'Submit Inquiry'}</button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}

export default PartnershipModal;
